import { useEffect, useState } from "react";
import { ReactComponent as OutlineCheckSmall } from "assets/svg/outline-check-small.svg";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  show: boolean;
  onHide?: () => void;
  /**
   * duration for the saved tag to show
   * @default 2000
   */
  duration?: number | null;
  message?: string;
  className?: string;
  top?: number;
};
const SuccessMessage = ({
  show,
  onHide,
  duration,
  message,
  className,
}: Props) => {
  const [localShow, setLocalShow] = useState(show);
  useEffect(() => setLocalShow(show), [show]);

  useEffect(() => {
    if (!localShow) {
      return;
    }
    if (!duration) {
      return;
    }
    const timer = setTimeout(() => {
      setLocalShow(false);
      onHide && onHide();
    }, duration ?? 2000);

    return () => timer && clearTimeout(timer);
  }, [localShow, onHide, duration]);

  return localShow ? (
    <div className={getClasses(className, styles["success-message"])}>
      <OutlineCheckSmall />
      <span className={styles["success-message__content-right"]}>
        {message}
      </span>
    </div>
  ) : null;
};

export default SuccessMessage;
